exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-lists-customers-create-customer .modal-content .button-row{margin-top:15px}#modal-lists-customers-create-customer .modal-content .default-card{width:1px}#modal-lists-customers-create-customer .modal-content .highlight-green{background-color:green}#modal-lists-customers-create-customer .modal-content .pending-card-row{background-color:#fff3cd;opacity:.8}#modal-lists-customers-create-customer .modal-content .table{width:100%}", ""]);

// exports
